import React from 'react';
import TextFieldWithRevert from './TextFieldWithRevert';
import CustomizableHtmlField from './CustomizableHtmlField';
import SmartVariablesPanel from './SmartVariablesPanel';

const NOTE_TEXT =
    'Note: Only default texts are automatically translated into the user’s language. Any changes you make turn the text into a custom version that is used exactly as written. For Header and Footer: when the checkbox is off, the translated default text is used; when it’s on, your custom content is used.';

const EmailTabContent = ({
    form,
    initialValue,
    subjectFieldName,
    greetingFieldName,
    headerFieldName,
    footerFieldName,
    headerLabel,
    footerLabel,
    smartVariables,
    onCopyVariable,
    onEnabledChange,
    defaultValues,
    onRevertField,
}) => {
    return (
        <div className="row">
            <div className="col-md-8">
                <br />
                <p
                    style={{
                        fontSize: '14px',
                        color: '#666',
                        fontStyle: 'italic',
                        marginBottom: '16px',
                    }}
                >
                    {NOTE_TEXT}
                </p>
                <div className="form-group">
                    <TextFieldWithRevert
                        field={form.$(subjectFieldName)}
                        defaultValue={defaultValues?.[`ui.email.${subjectFieldName}`]}
                        onRevert={onRevertField}
                    />
                </div>
                <div className="form-group">
                    <TextFieldWithRevert
                        field={form.$(greetingFieldName)}
                        defaultValue={defaultValues?.[`ui.email.${greetingFieldName}`]}
                        onRevert={onRevertField}
                    />
                </div>
                <CustomizableHtmlField
                    label={headerLabel}
                    fieldName={headerFieldName}
                    enabledFieldName={`${headerFieldName}Enabled`}
                    form={form}
                    initialValue={initialValue}
                    onEnabledChange={onEnabledChange}
                />
                <CustomizableHtmlField
                    label={footerLabel}
                    fieldName={footerFieldName}
                    enabledFieldName={`${footerFieldName}Enabled`}
                    form={form}
                    initialValue={initialValue}
                    onEnabledChange={onEnabledChange}
                />
            </div>
            <div className="col-md-4">
                <SmartVariablesPanel
                    variables={smartVariables}
                    onCopyVariable={onCopyVariable}
                />
            </div>
        </div>
    );
};

export default EmailTabContent;

